import { BRANDS_BLOCKED } from "../../../../utils/constants";

const BRAND_SETUP_TEXT_FIELDS = [
  "businessName",
  "businessDescription",
  "businessTextStyle",
  "businessLookAndFeel",
  "businessValueProposition",
  "businessOffering",
  "businessIdealCustomerProfile",
  "logoUrl",
  "businessCountry",
  "businessTypography",
  "businessTypographyPreview",
  "websiteUrl",
];

const MODAL_CREATE_WITH_IA_TEXT_FIELDS = [
  "prompt",
  "businessLookAndFeel",
  "websiteUrl",
  "referenceAdUrl",
];

const getBlockedBrands = () =>
  Object.values(BRANDS_BLOCKED || {})
    .filter(Boolean)
    .map((brand) => String(brand).toLowerCase().trim());

const getTextFromUnknownValue = ({ value } = {}) => {
  if (typeof value === "string") return value;
  if (value === null || value === undefined) return "";
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  if (Array.isArray(value)) {
    return value
      .map((item) => getTextFromUnknownValue({ value: item }))
      .join(" ");
  }
  if (typeof value === "object") {
    return Object.values(value)
      .map((item) => getTextFromUnknownValue({ value: item }))
      .join(" ");
  }
  return "";
};

export const getBlockedBrandFromText = ({ text = "" } = {}) => {
  const normalizedText = getTextFromUnknownValue({ value: text })
    .toLowerCase()
    .trim();
  if (!normalizedText) return null;
  const blockedBrands = getBlockedBrands();
  return blockedBrands.find((brand) => normalizedText.includes(brand)) || null;
};

export const shouldApplyBlockedBrandsValidation = ({
  isPlanActive = false,
  isTrial = false,
} = {}) => {
  return !isPlanActive || isTrial;
};

export const validateTextDoesNotContainBlockedBrands = ({
  value = "",
} = {}) => {
  if (!value) return true;
  const blockedBrand = getBlockedBrandFromText({ text: value });
  return !blockedBrand;
};

export const validateBlockedBrandByPlanStatus = ({
  value = "",
  isPlanActive = false,
  isTrial = false,
} = {}) => {
  if (
    !shouldApplyBlockedBrandsValidation({
      isPlanActive,
      isTrial,
    })
  ) {
    return true;
  }

  return validateTextDoesNotContainBlockedBrands({ value });
};

const validateTextFields = ({
  values = {},
  fields = [],
  isPlanActive = false,
  isTrial = false,
} = {}) => {
  if (
    !shouldApplyBlockedBrandsValidation({
      isPlanActive,
      isTrial,
    })
  ) {
    return;
  }

  for (const fieldName of fields) {
    const fieldValue = values?.[fieldName];
    const blockedBrand = getBlockedBrandFromText({ text: fieldValue });
    if (blockedBrand) {
      throw new Error("The request could not be processed.");
    }
  }
};

export const validateBrandSetupTextFields = ({
  formData = {},
  isPlanActive = false,
  isTrial = false,
} = {}) => {
  validateTextFields({
    values: formData,
    fields: BRAND_SETUP_TEXT_FIELDS,
    isPlanActive,
    isTrial,
  });
};

export const validateModalCreateWithIATextFields = ({
  formData = {},
  isPlanActive = false,
  isTrial = false,
} = {}) => {
  validateTextFields({
    values: formData,
    fields: MODAL_CREATE_WITH_IA_TEXT_FIELDS,
    isPlanActive,
    isTrial,
  });
};

export const validateModalImageEditTextFields = ({
  prompt = "",
  isPlanActive = false,
  isTrial = false,
} = {}) => {
  validateTextFields({
    values: { prompt },
    fields: ["prompt"],
    isPlanActive,
    isTrial,
  });
};
